export function serviceRequiresClientForm(service?: {
  requires_client_form?: number | boolean | null
}): boolean {
  if (!service) return true
  const value = service.requires_client_form
  if (value === undefined || value === null) return true
  return Number(value) !== 0
}
